import { type PropsWithChildren } from "react";

import UtilsContextProvider from "./UtilsContext";
import AuthContextProvider from "./Auth";
import GoogleOauthProvider from "./GoogleOauth";

export default function GlobalContext({ children }: PropsWithChildren<unknown>) {
    return (
        <UtilsContextProvider>
            <GoogleOauthProvider>
                <AuthContextProvider>{children}</AuthContextProvider>
            </GoogleOauthProvider>
        </UtilsContextProvider>
    );
}
